import {createSlice, PayloadAction} from "@reduxjs/toolkit"
import {asyncCreator} from "./sliceHelper"
import {WSObjectSchedule} from "../types/WebSocketTypes"
import {objectScheduleApi} from "../api/objectScheduleApi"
import {ObjectScheduleResponse, ObjectSchedulesResponse} from "../models/response"

type InitialStateType = {
    schedules: null | ObjectSchedulesResponse
    schedule: null | ObjectScheduleResponse
    ws: WSObjectSchedule | null
}

const initialState: InitialStateType = {
    schedules: null,
    schedule: null,
    ws: null,
}

export const objectScheduleReducer = createSlice({
    name: 'objectScheduleReducer',
    initialState,
    reducers: {
        setObjectSchedules(state, {payload}) {
            state.schedules = payload
        },
        setObjectSchedule(state, {payload}) {
            state.schedule = payload
        },
        addObjectSchedule(state, {payload}) {
            if (state.schedules) {
                state.schedules = {
                    total: state.schedules.total += 1,
                    data: [payload, ...state.schedules.data],
                }
            }
        },
        editObjectSchedule(state, {payload}: PayloadAction<ObjectScheduleResponse>) {
            let index = state.schedules?.data.findIndex(i => i.id === payload.id)
            if (index !== undefined && state.schedules) state.schedules.data[index] = payload
            if (state.schedule) state.schedule = payload
        },
        setWSObjectSchedule(state, {payload}: PayloadAction<WSObjectSchedule | null>) {
            state.ws = payload
        },
    },
})

export const {setObjectSchedules, setObjectSchedule, addObjectSchedule, editObjectSchedule, setWSObjectSchedule} = objectScheduleReducer.actions

export default objectScheduleReducer.reducer

export const getObjectSchedules = asyncCreator
('objectScheduleReducer/getObjectSchedules', objectScheduleApi.getSchedules, setObjectSchedules)

export const getObjectSchedule = asyncCreator
('objectScheduleReducer/getObjectSchedule', objectScheduleApi.getSchedule, setObjectSchedule)

export const createObjectSchedule = asyncCreator
('objectScheduleReducer/createObjectSchedule', objectScheduleApi.createSchedule, addObjectSchedule)

export const changeObjectSchedule = asyncCreator
('objectScheduleReducer/changeObjectSchedule', objectScheduleApi.changeSchedule, editObjectSchedule)

export const deleteObjectSchedule = asyncCreator
('objectScheduleReducer/deleteObjectSchedule', objectScheduleApi.deleteSchedule)